// == Unichat Extension ==
import { frontendURL } from 'dashboard/helper/URLHelper';
import SettingsWrapper from 'dashboard/routes/dashboard/settings/SettingsWrapper.vue';
import PendingAgentsIndex from '../views/pending_agents/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/unichat/pending-agents'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'unichat_pending_agents',
          component: PendingAgentsIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
